import type { TOC } from '@ember/component/template-only';
import type { EventOrHoliday } from 'lumen/components/hotel/rates/tooltips/short-term-rental-tooltip';
import dayjsFormat from 'lumen/helpers/dayjs-format';
import type { PartialDateFormatType } from 'lumen/utils/constants/general-constants';

import styles from './short-term-rental-event-item.module.css';

interface HotelShortTermRentalShortTermRentalEventItemSignature {
  Args: {
    event: EventOrHoliday;
    partialDateFormat: PartialDateFormatType;
  };
}

const HotelShortTermRentalShortTermRentalEventItem = <template>
  <div>
    <p class="text-200--regular {{styles.event-name}}">{{@event.name}}</p>
    <p class="text-200--regular">{{dayjsFormat
        @event.startDate
        format=@partialDateFormat.WEEKDAY_AND_MONTH_AND_DAY_MEDIUM
      }}
      {{#unless @event.isSingleDay}}
        -
        {{dayjsFormat
          @event.endDate
          format=@partialDateFormat.WEEKDAY_AND_MONTH_AND_DAY_MEDIUM
        }}
      {{/unless}}
    </p>
  </div>
</template> satisfies TOC<HotelShortTermRentalShortTermRentalEventItemSignature>;

export default HotelShortTermRentalShortTermRentalEventItem;
